<template>
  <svg width="100%" height="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M7.74167 6.76665L10.975 9.99999L7.74167 13.2333C7.41667 13.5583 7.41667 14.0833 7.74167 14.4083C8.06667 14.7333 8.59167 14.7333 8.91667 14.4083L12.7417 10.5833C13.0667 10.2583 13.0667 9.73332 12.7417 9.40832L8.91667 5.58332C8.59167 5.25832 8.06667 5.25832 7.74167 5.58332C7.42501 5.90832 7.41667 6.44165 7.74167 6.76665Z"
        fill="currentColor"/>
  </svg>
</template>